<div class="cta">
  <header class="cta-head">
    <button class="cta-atras" (click)="atras()">&larr; Campa&ntilde;as</button>

    <h2>{{ campana.nombre }}</h2>
    <span class="mono codigo">{{ campana.codigo }}</span>
    <span class="pill mini" [ngClass]="campana.estado.toLowerCase()">
      {{ campana.estado.toLowerCase() }}
    </span>
    <span class="pill mini bad" *ngIf="campana.pausadaMotivo === 'VELOCIDAD'">
      la fren&oacute; el ritmo
    </span>

    <button class="cta-refrescar" (click)="refrescar()">Actualizar</button>
  </header>

  <p class="cta-sub">
    {{ campana.alcanceCodigo }} &middot;
    <span *ngIf="campana.alcancePublico === 'TODOS'">todos</span>
    <span *ngIf="campana.alcancePublico === 'SIN_ENVIOS'">nuevos, sin ning&uacute;n env&iacute;o</span>
    <span *ngIf="campana.alcancePublico === 'INACTIVO'">
      inactivos hace {{ campana.inactivoDias }} d&iacute;as
    </span>
    &middot; bono de <b>{{ campana.monto }} {{ campana.moneda }}</b>
    &middot; del {{ campana.vigenciaDesde | date: 'dd/MM/yy' }}
    al {{ campana.vigenciaHasta | date: 'dd/MM/yy' }}
  </p>

  <div class="cta-cargando" *ngIf="cargando">Cargando&hellip;</div>
  <div class="cta-error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!cargando && resumen">
    <!-- Las cifras -->
    <div class="cta-nums">
      <div class="cta-num">
        <span class="n">{{ resumen.unidades.usadas }}<small> / {{ resumen.unidades.total }}</small></span>
        <span class="l">bonos tomados</span>
        <span class="barra"><i [style.width.%]="avanceCupo"></i></span>
      </div>

      <div class="cta-num warn">
        <span class="n">{{ resumen.comprometido }}</span>
        <span class="l">comprometido</span>
        <span class="h">reservas vivas m&aacute;s lo pagado</span>
      </div>

      <div class="cta-num">
        <span class="n">{{ resumen.pagado }}</span>
        <span class="l">pagado en {{ resumen.moneda }}</span>
        <span class="h">lo que ya sali&oacute;</span>
      </div>

      <!-- El ritmo. Se mira antes de que salte el freno, no después. -->
      <div class="cta-num" [class.alerta]="ritmoAlto">
        <span class="n">
          {{ resumen.ritmo.tomadosEnVentana }}<small *ngIf="resumen.ritmo.umbral"> / {{ resumen.ritmo.umbral }}</small>
        </span>
        <span class="l">ritmo</span>
        <span class="h" *ngIf="resumen.ritmo.ventanaMinutos">
          en los &uacute;ltimos {{ resumen.ritmo.ventanaMinutos }} min
        </span>
        <span class="h" *ngIf="!resumen.ritmo.umbral">sin freno configurado</span>
      </div>

      <div class="cta-num" [class.alerta]="resumen.senalesPorRevisar > 0">
        <span class="n">{{ resumen.senalesPorRevisar }}</span>
        <span class="l">se&ntilde;ales</span>
        <span class="h">filas que vale mirar</span>
      </div>
    </div>

    <p class="cta-aviso" *ngIf="ritmoAlto">
      El ritmo est&aacute; cerca del umbral: si lo pasa, la campa&ntilde;a se pausa sola.
      Mir&aacute; los rechazos de abajo antes de que eso pase &mdash; ahora
      todav&iacute;a se puede decidir algo.
    </p>

    <!-- Los rechazos por motivo: el mapa de qué está frenando -->
    <div class="cta-rechazos" *ngIf="resumen.rechazos.length">
      <span class="cta-titulo">Qu&eacute; est&aacute; frenando</span>
      <div class="cta-motivos">
        <span
          class="pill"
          *ngFor="let r of resumen.rechazos"
          [class.bad]="motivoSospechoso(r.motivo)"
        >
          {{ motivoTexto(r.motivo) }} <b>{{ r.veces }}</b>
        </span>
      </div>
      <small class="cta-pista">
        Un c&oacute;digo inexistente o fuera de vigencia es ruido esperable: las capturas
        del c&oacute;digo circulan para siempre. Lo que no es ruido es
        <b>documento ya cobr&oacute;</b> repetido &mdash;alguien reintentando con varias
        cuentas&mdash; y <b>cre&oacute; o activ&oacute; la campa&ntilde;a</b>.
      </small>
    </div>

    <!-- La tabla -->
    <div class="cta-tabla-head">
      <span class="cta-titulo">Reclamos</span>
      <label class="cta-check">
        <input type="checkbox" [checked]="incluirRechazos" (change)="alternarRechazos()" />
        <span>Incluir los rechazados</span>
      </label>
    </div>

    <p class="cta-pista" *ngIf="incluirRechazos">
      Los rechazos se listan junto a los aceptados a prop&oacute;sito: un tablero que
      s&oacute;lo muestra qui&eacute;n cobr&oacute; deja invisible al que prob&oacute;
      veinte veces.
    </p>

    <div class="cta-tabla-wrap">
      <p class="cta-vacio" *ngIf="cargandoTabla">Buscando&hellip;</p>
      <p class="cta-vacio" *ngIf="!cargandoTabla && !filas.length">
        Todav&iacute;a nadie intent&oacute; reclamar esta campa&ntilde;a.
      </p>

      <table *ngIf="!cargandoTabla && filas.length">
        <thead>
          <tr>
            <th>Cu&aacute;ndo</th>
            <th>Qui&eacute;n</th>
            <th>Documento</th>
            <th>Resultado</th>
            <th>Bono</th>
            <th>Se&ntilde;ales</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let f of filas"
            [class.rechazado]="!aceptado(f)"
            [class.consenal]="conSenal(f)"
          >
            <td class="dim">{{ f.fecha | date: 'dd/MM/yy HH:mm' }}</td>

            <td>
              <strong>{{ f.quien.nombre || '&mdash;' }}</strong>
              <span class="dim small" *ngIf="f.quien.usuarioId">#{{ f.quien.usuarioId }}</span>
            </td>

            <!-- Enmascarado por el backend. El operador reconoce a la persona y
                 ve la repetición; el número completo no viaja. -->
            <td>
              <span class="mono" *ngIf="f.documento.enmascarado">
                {{ f.documento.tipo }} {{ f.documento.enmascarado }}
              </span>
              <span class="dim" *ngIf="!f.documento.enmascarado">&mdash;</span>
            </td>

            <td>
              <span class="pill ok" *ngIf="aceptado(f)">aceptado</span>
              <span class="pill" *ngIf="!aceptado(f)" [class.bad]="f.motivo && motivoSospechoso(f.motivo)">
                {{ motivoTexto(f.motivo) }}
              </span>
            </td>

            <td>
              <span *ngIf="f.monto">
                <strong>{{ f.monto }}</strong> <span class="mono">{{ f.moneda }}</span>
              </span>
              <span class="pill mini" *ngIf="f.estado">{{ estadoTexto(f.estado) }}</span>
              <span class="dim small" *ngIf="f.expiraAt && f.estado === 'RETENIDO'">
                vence {{ f.expiraAt | date: 'dd/MM/yy' }}
              </span>
              <span class="dim" *ngIf="!f.monto">&mdash;</span>
            </td>

            <td>
              <span class="pill mini bad" *ngFor="let s of f.senales">{{ s }}</span>
              <span class="dim" *ngIf="!f.senales?.length">&mdash;</span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="cta-paginado" *ngIf="total > limit">
        <button [disabled]="page <= 1" (click)="irAPagina(page - 1)">Anterior</button>
        <span>{{ page }} de {{ totalPaginas }} &middot; {{ total }} intentos</span>
        <button [disabled]="page >= totalPaginas" (click)="irAPagina(page + 1)">
          Siguiente
        </button>
      </div>
    </div>
  </ng-container>
</div>
